(function () {
  if (window.SimplicistInteractions && window.SimplicistInteractions.loaded) return;

  var api = window.SimplicistInteractions || {};
  api.loaded = true;

  api.initReveal = function initReveal(scope) {
    var root = scope || document;
    var items = root.querySelectorAll("[data-ss-reveal]");
    if (!items.length) return;

    if (!("IntersectionObserver" in window)) {
      items.forEach(function (item) { item.classList.add("is-visible"); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    items.forEach(function (item) {
      if (item.dataset.ssRevealBound === "true") return;
      item.dataset.ssRevealBound = "true";
      observer.observe(item);
    });
  };

  api.initTilt = function initTilt(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-ss-tilt]").forEach(function (target) {
      if (target.dataset.ssTiltBound === "true") return;
      target.dataset.ssTiltBound = "true";

      target.addEventListener("pointermove", function (event) {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        var rect = target.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        target.style.transform = "rotateX(" + (y * -4) + "deg) rotateY(" + (x * 6) + "deg)";
      });

      target.addEventListener("pointerleave", function () {
        target.style.transform = "rotateX(0deg) rotateY(0deg)";
      });
    });
  };

  api.showToast = function showToast(message) {
    var toast = document.querySelector("[data-ss-toast]");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "ss-toast";
      toast.setAttribute("data-ss-toast", "");
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(api.toastTimer);
    api.toastTimer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 2200);
  };

  api.getCartSectionIds = function getCartSectionIds() {
    var ids = ["cart-drawer", "cart-icon-bubble", "main-cart-items"];
    var cartElement = document.querySelector("cart-drawer") || document.querySelector("#CartDrawer");

    if (cartElement && typeof cartElement.getSectionsToRender === "function") {
      try {
        cartElement.getSectionsToRender().forEach(function (section) {
          if (section && section.id) ids.push(section.id);
        });
      } catch (error) {}
    }

    return ids.filter(function (id, index) {
      return id && ids.indexOf(id) === index;
    });
  };

  api.syncCart = function syncCart(cartData) {
    cartData = cartData || {};

    return Promise.resolve()
      .then(function () {
        if (cartData.sections) return cartData;

        var sectionUrl = (window.location.pathname || "/") + "?sections=" + api.getCartSectionIds().join(",");
        return fetch(sectionUrl, { credentials: "same-origin" })
          .then(function (response) {
            if (!response.ok) return cartData;
            return response.json().then(function (sections) {
              cartData.sections = sections;
              return cartData;
            });
          });
      })
      .then(function () {
        var drawerElement = document.querySelector("cart-drawer") || document.querySelector("#CartDrawer");

        if (drawerElement && typeof drawerElement.renderContents === "function") {
          try {
            drawerElement.renderContents(cartData);
          } catch (error) {}
        }

        if (cartData.sections) {
          var parser = new DOMParser();

          if (cartData.sections["cart-icon-bubble"]) {
            var iconDoc = parser.parseFromString(cartData.sections["cart-icon-bubble"], "text/html");
            var currentIcon = document.querySelector("#cart-icon-bubble");
            var newIcon = iconDoc.querySelector("#cart-icon-bubble") ||
              iconDoc.querySelector(".cart-icon-bubble") ||
              iconDoc.querySelector(".cart-count-bubble");

            if (currentIcon && newIcon) currentIcon.outerHTML = newIcon.outerHTML;
          }

          var drawerHtml = cartData.sections["cart-drawer"] || cartData.sections["main-cart-items"];
          if (drawerHtml && drawerElement) {
            var drawerDoc = parser.parseFromString(drawerHtml, "text/html");
            var newInner = drawerDoc.querySelector(".drawer__inner") ||
              drawerDoc.querySelector("#CartDrawer") ||
              drawerDoc.querySelector("cart-drawer") ||
              drawerDoc.body;
            var currentInner = drawerElement.querySelector(".drawer__inner") ||
              drawerElement.querySelector("#CartDrawer") ||
              drawerElement;

            if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
          }
        }

        document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: cartData }));
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: cartData }));

        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { cart: cartData });
        }

        window.setTimeout(function () {
          var updatedDrawer = document.querySelector("cart-drawer") || document.querySelector("#CartDrawer");

          if (updatedDrawer) {
            if (typeof updatedDrawer.open === "function") updatedDrawer.open();
            else if (typeof updatedDrawer.setActive === "function") updatedDrawer.setActive(true);
            else updatedDrawer.setAttribute("open", "");
          }

          var nativeTrigger = document.querySelector(".header__icon--cart") ||
            document.querySelector("#cart-icon-bubble") ||
            document.querySelector("cart-drawer-trigger button") ||
            document.querySelector(".cart-drawer-trigger");

          if (nativeTrigger && nativeTrigger.click && !(nativeTrigger.getAttribute("href") || "").includes("/cart")) {
            nativeTrigger.click();
          }
        }, 180);

        return cartData;
      });
  };

  api.addProductsToCart = function addProductsToCart(items) {
    var cartItems = (items || [])
      .map(function (item) {
        if (typeof item === "number" || typeof item === "string") {
          return { id: Number(item), quantity: 1 };
        }

        return {
          id: Number(item.id),
          quantity: Number(item.quantity || 1)
        };
      })
      .filter(function (item) {
        return item.id && item.quantity > 0;
      });

    if (!cartItems.length) {
      return Promise.reject(new Error("No products selected"));
    }

    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: cartItems,
        sections: api.getCartSectionIds().join(","),
        sections_url: window.location.pathname || "/"
      })
    })
      .then(function (response) {
        return response.json().then(function (cartData) {
          if (!response.ok) throw cartData;
          return api.syncCart(cartData);
        });
      });
  };

  api.initCartAddButtons = function initCartAddButtons(scope) {
    var root = scope || document;

    root.querySelectorAll("[data-ss-cart-add]").forEach(function (button) {
      if (button.dataset.ssCartAddBound === "true") return;
      button.dataset.ssCartAddBound = "true";

      button.addEventListener("click", function () {
        var variantIds = (button.dataset.variantIds || "")
          .split(",")
          .map(function (id) { return id.trim(); })
          .filter(function (id, index, ids) {
            return id && ids.indexOf(id) === index;
          });

        if (!variantIds.length || button.disabled) return;

        var originalText = button.innerHTML;
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        button.innerHTML = "Adding...";

        api.addProductsToCart(variantIds)
          .then(function () {
            button.innerHTML = "Added";
            api.showToast("Added to cart.");
            window.setTimeout(function () {
              button.innerHTML = originalText;
            }, 1200);
          })
          .catch(function () {
            button.innerHTML = originalText;
            api.showToast("Could not add to cart. Please try again.");
          })
          .finally(function () {
            window.setTimeout(function () {
              button.disabled = false;
              button.setAttribute("aria-busy", "false");
            }, 1200);
          });
      });
    });
  };

  api.initQuickAdd = function initQuickAdd(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-ss-quick-add]").forEach(function (button) {
      if (button.dataset.ssQuickAddBound === "true") return;
      button.dataset.ssQuickAddBound = "true";

      button.addEventListener("click", function () {
        var variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        button.disabled = true;
        button.setAttribute("aria-busy", "true");

        api.addProductsToCart([{ id: variantId, quantity: 1 }])
          .then(function () {
            api.showToast("Added to cart.");
          })
          .catch(function () {
            api.showToast("Could not add to cart. Please try again.");
          })
          .finally(function () {
            button.disabled = false;
            button.setAttribute("aria-busy", "false");
          });
      });
    });
  };

  api.init = function init(scope) {
    api.initReveal(scope);
    api.initTilt(scope);
    api.initCartAddButtons(scope);
    api.initQuickAdd(scope);
  };

  window.SimplicistInteractions = api;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { api.init(document); });
  } else {
    api.init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    api.init(event.target);
  });
})();
